import React, { forwardRef, useImperativeHandle, useState } from 'react';
import styled from 'styled-components';

import Footer from 'src/presentation/components/forms/Footer';
import { Button } from 'src/presentation/components/agent_desktop_components';
import { StyledConfirmOrCancelModal } from 'src/presentation/components/pages/shared/rowActions/StyledConfirmOrCancelModal';

export interface WarnProps {
  submitText: string;
  cancelText: string;
  title: string;
  text?: string;
  content?: Node;
}

type ActionsProps = {
  isLoading?: boolean;
  onClose: Function;
  onHelp?: Function;
  onSave: Function;
  warnProps?: WarnProps;
};

// A wrapper over action buttons to pass the same onClose handler to the modal closing button ('X')
const ActionsFooter = forwardRef((props: ActionsProps, ref) => {
  const [showWarnModal, setShowWarnModal] = useState<boolean>(false);
  const { isLoading, onClose, onSave, onHelp, warnProps } = props;

  useImperativeHandle(ref, () => ({
    onCloseHandler: onClose,
  }));

  let onModalCancel, onModalSubmit, onSaveClick;

  if (warnProps) {
    onModalCancel = () => setShowWarnModal(false);
    onModalSubmit = () => {
      setShowWarnModal(false);
      onSave();
    };
    onSaveClick = () => setShowWarnModal(true);
  } else {
    onSaveClick = onSave;
  }

  return (
    <Footer>
      {showWarnModal && warnProps ? (
        <ConfirmOrCancelModal
          cancelText={warnProps.cancelText}
          confirmOnDismiss={false}
          data-aid={'warn-confirm-cancel-modal'}
          onCancel={onModalCancel}
          onSubmit={onModalSubmit}
          submitText={warnProps.submitText}
          children={warnProps.content || <ConfirmOrCancelModalContent text={warnProps.text} />}
          title={warnProps.title}
        />
      ) : null}
      {onHelp && (
        <Button data-aid={'editor-need-help'} type={Button.Types.SECONDARY} onClick={onHelp}>
          Need Help?
        </Button>
      )}
      <Button data-aid={'editor-cancel'} type={Button.Types.TEXT} onClick={onClose} style={{ marginLeft: 'auto' }}>
        Cancel
      </Button>
      <Button data-aid={'editor-save'} onClick={onSaveClick} isLoading={isLoading}>
        Save
      </Button>
    </Footer>
  );
});

const ConfirmOrCancelModalContent = ({ text }) => {
  return (
    <div>
      <p>{text}</p>
    </div>
  );
};

const ConfirmOrCancelModal = styled(StyledConfirmOrCancelModal)`
  .modalCard-content {
    width: 20%;
  }
`;

export default ActionsFooter;
